/* ============================================
   CUSTOM PRODUCT CARD - QUANTITY BUTTONS
   Add this to your theme's assets folder as:
   custom-product-cards.js
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    // Handle minus button
    if (e.target.closest('.custom-qty-minus')) {
      var input = e.target.closest('.custom-product-card__qty').querySelector('.custom-qty-input');
      var currentVal = parseInt(input.value) || 1;
      if (currentVal > 1) {
        input.value = currentVal - 1;
      }
    }

    // Handle plus button
    if (e.target.closest('.custom-qty-plus')) {
      var input = e.target.closest('.custom-product-card__qty').querySelector('.custom-qty-input');
      var currentVal = parseInt(input.value) || 1;
      input.value = currentVal + 1;
    }
  });
});